import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Alert — inline message banner. tone: success | error | info | warning.
   Token-driven, theme-correct; role="alert" for assertive tones so screen
   readers announce errors/warnings. Replaces @material-ui/lab Alert
   (REG-378 part 3, FR-002). */

const TONES = {
  success: { icon: "checkCircle", color: "var(--green-success)" },
  error: { icon: "alertTriangle", color: "var(--red)" },
  warning: { icon: "alertTriangle", color: "var(--orange)" },
  info: { icon: "info", color: "var(--blue-info)" },
};

export function Alert({ tone = "info", title, children, onDismiss, style, ...rest }) {
  const t = TONES[tone] || TONES.info;
  const assertive = tone === "error" || tone === "warning";
  return (
    <div
      role={assertive ? "alert" : "status"}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        padding: "12px 14px",
        background: "var(--surface-card)",
        border: "1px solid var(--border)",
        borderLeft: `3px solid ${t.color}`,
        borderRadius: "var(--radius-md)",
        ...style,
      }}
      {...rest}
    >
      <span style={{ marginTop: 1, color: t.color, flex: "none" }}>
        <Icon name={t.icon} size={18} />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title ? (
          <div style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: 14, color: "var(--text-strong)" }}>
            {title}
          </div>
        ) : null}
        {children ? (
          <div
            style={{
              fontFamily: "var(--font-sans)",
              fontWeight: 500,
              fontSize: 13,
              color: "var(--text-body)",
              marginTop: title ? 2 : 0,
            }}
          >
            {children}
          </div>
        ) : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onDismiss}
          style={{
            border: "none",
            background: "transparent",
            color: "var(--text-muted)",
            cursor: "pointer",
            flex: "none",
            display: "inline-flex",
            padding: 2,
          }}
        >
          <Icon name="x" size={16} />
        </button>
      ) : null}
    </div>
  );
}

export default Alert;
